/* Les assets d'un theme Shopify vivent sous un chemin versionne que seul
   Liquid connait. FN_ASSETS est publie par layout/theme.liquid ; le repli
   sur le nom nu evite une image cassee si la table venait a manquer. */
function FN_A(n){ return (window.FN_ASSETS && window.FN_ASSETS[n]) || n; }

/* ============================================================
   FRAISE NOIRE — HOME (interactions)
   Lenis (desktop) · GSAP reveals · grille hover conditionnel · panier drawer
   ============================================================ */
(() => {
  'use strict';
  const PRODUCTS = window.FN_PRODUCTS || [];
  const $  = (s, c = document) => c.querySelector(s);
  const $$ = (s, c = document) => [...c.querySelectorAll(s)];
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const touch  = matchMedia('(hover: none)').matches;
  const eur = n => n.toLocaleString('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';

  /* ---------- GRILLE PRODUITS ---------- */
  function matchCat(p, key) {
    const c = (p.cat || '').toLowerCase(), k = key.toLowerCase();
    return c === k || c.startsWith(k) || c.includes(k);
  }
  /* Badge « Nouveau » : reserve a une liste courte de handles (dernieres entrees
     du catalogue — proposition a valider par Hedy/Fabien). Avant : 72 produits
     sur 75 badges « Nouveau » = signal mort + allegation de nouveaute infondee. */
  const NEW_HANDLES = new Set([
    'survetement-amsterdam', 'survetement-pink-design-1', 'survetement-pink-design',
    'survetement-essential-bleu-marine', 'survetement-essential-blanc',
    'survetement-essential-vert-kaki', 'survetement-essential-gris-chine',
    'hoodies-design-a-capuche-13mars', 'hoodie-design-a-capuche-crime-scene',
  ]);
  /* ---------- IMAGES RESPONSIVES ----------
     Sert du WebP en 600/1200 px selon l'écran, avec l'original
     (jpg/png) en repli pour les navigateurs sans WebP.
     Une image déjà en .webp est servie telle quelle. */
  const CONVERTIBLE = /\.(jpe?g|png)(\?|$)/i;
  /* Les photos produits viennent desormais du CDN Shopify, qui redimensionne
     par le parametre `width` de l'URL. Fabriquer « nom-600.webp » comme en
     local y produisait 8 images 404 : ces fichiers n'existent pas la-bas.
     On detecte donc la provenance et on parle la langue du bon serveur. */
  const SUR_CDN = /\/cdn\/shop\//i;
  function largeur(url, px) {
    // `width` peut deja etre present (Liquid en pose un) : on le remplace.
    const u = url.replace(/([?&])width=\d+/i, '$1width=' + px);
    if (/[?&]width=/i.test(u)) return u;
    return u + (u.includes('?') ? '&' : '?') + 'width=' + px;
  }
  /* LES MEMES PALIERS ET LE MEME `sizes` QUE LE LIQUID — SINON TOUT EST TELECHARGE DEUX FOIS.
     La grille d'un rayon est rendue par le serveur (snippets/carte-produit.liquid),
     puis RE-RENDUE ici des que shop.js applique un filtre ou un tri. Tant que les
     deux listes de tailles differaient (400/700/1200 contre 300/450/550/700/1000)
     et que `sizes` annoncait 50vw d'un cote et 45vw de l'autre, le navigateur
     choisissait une largeur differente a chaque rendu : il retelechargeait les
     memes photos en 700 px apres les avoir prises en 550 px.
     Mesure du 13/10 sur /collections/casquettes, telephone en 4G bridee :
     44 images pour 39 produits, 3,7 Mo — dont 20 en double. */
  const PALIERS_CARTE = [300, 450, 550, 700, 1000];
  function media(src, attrs, tailles) {
    if (!src) return '';
    const taille = tailles || '(max-width: 760px) 45vw, 22vw';

    if (SUR_CDN.test(src)) {
      return `<img src="${largeur(src, 550)}"`
        + ` srcset="${PALIERS_CARTE.map(p => `${largeur(src, p)} ${p}w`).join(', ')}"`
        + ` sizes="${taille}" ${attrs}>`;
    }

    if (!CONVERTIBLE.test(src)) return `<img src="${src}" ${attrs}>`;
    const [chemin, q] = src.split('?');
    const base = chemin.replace(/\.(jpe?g|png)$/i, '');
    const v = q ? '?' + q : '';
    return `<picture style="display:contents">`
      + `<source type="image/webp" srcset="${base}-600.webp${v} 600w, ${base}-1200.webp${v} 1200w" sizes="${taille}">`
      + `<img src="${src}" ${attrs}>`
      + `</picture>`;
  }

  /* ---------- ECHAPPEMENT ----------
     Tout ce qui est injecte en innerHTML doit passer par la.

     · `esc` pour du CONTENU. La note de broderie est tapee par le visiteur
       (/:477), stockee dans le panier, puis reinjectee a chaque
       chargement : sans echappement, `<svg onload=...>` — vingt caracteres,
       exactement la limite du champ — s'execute sur toutes les pages, pour
       toujours. C'est un XSS persistant, pas une coquetterie.
     · `att` pour un ATTRIBUT. Seize titres du catalogue contiennent des
       guillemets droits (« Hoodie "Mars 13" Blanc ») : dans `alt="${title}"`
       ils ferment l'attribut et tronquent le texte alternatif. */
  const ESCAPES = { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' };
  const esc = v => String(v == null ? '' : v).replace(/[&<>"']/g, c => ESCAPES[c]);
  const att = esc;

  function card(p) {
    const has2 = !!p.img2;
    const cls = 'card' + (has2 ? ' has-2' : '');
    const badge = !p.available
      ? '<span class="card__badge card__badge--out">Épuisé</span>'
      : (NEW_HANDLES.has(p.handle) ? '<span class="card__badge">Nouveau</span>' : '');
    const back = has2 ? media(p.img2, 'class="card__img card__img--back" alt="" width="928" height="1152" loading="lazy" aria-hidden="true"') : '';
    const sizes = (p.available && p.sizes && p.sizes.length)
      ? `<div class="card__add">${p.sizes.map(s => `<button class="card__size" data-add="${att(p.handle)}" data-size="${att(s)}">${esc(s)}</button>`).join('')}</div>`
      : '';
    return `<article class="${cls}">
      <div class="card__media">
        ${badge}
        <button class="card__wish" aria-label="Ajouter aux favoris"><svg viewBox="0 0 24 24" width="17" height="17" fill="none" stroke="currentColor" stroke-width="1.7"><path d="M12 20S4 14.6 4 9.2A4.2 4.2 0 0 1 12 7a4.2 4.2 0 0 1 8 2.2C20 14.6 12 20 12 20Z"/></svg></button>
        ${media(p.img, `class="card__img card__img--front" alt="${att(p.title)}" width="928" height="1152" loading="lazy"`)}
        ${back}
        ${sizes}
        <a class="card__link" href="${p.url || "/products/" + p.handle}" aria-label="${att(p.title)}"></a>
      </div>
      <div class="card__info">
        <div><span class="card__name">${esc(p.title)}</span><span class="card__cat">${esc(p.cat)}</span></div>
        <span class="card__price tabular">${eur(p.price)}</span>
      </div>
    </article>`;
  }
  /* Compteurs de pièces des tuiles univers — toujours synchrones avec le catalogue */
  $$('[data-count]').forEach(el => {
    const n = PRODUCTS.filter(p => matchCat(p, el.dataset.count)).length;
    if (n) el.textContent = n + (n > 1 ? ' pièces' : ' pièce');
  });

  $$('[data-grid]').forEach(grid => {
    const key = grid.dataset.grid, lim = parseInt(grid.dataset.limit || '8', 10);
    const list = PRODUCTS.filter(p => matchCat(p, key) && p.img).slice(0, lim);
    grid.innerHTML = list.map(card).join('');
  });

  /* ---------- CARROUSEL DÉFILANT (rail) ----------
     data-handles (liste curatee, ordre respecte) prioritaire sur data-cat.
     Les produits epuises sont exclus des rails : une vitrine qui promene des
     pieces invendables est un anti-pattern. */
  $$('[data-rail]').forEach(rail => {
    const lim = parseInt(rail.dataset.limit || '12', 10);
    let list;
    if (rail.dataset.handles) {
      list = rail.dataset.handles.split(',').map(h => PRODUCTS.find(p => p.handle === h.trim()))
        .filter(p => p && p.img && p.available).slice(0, lim);
    } else {
      list = PRODUCTS.filter(p => matchCat(p, rail.dataset.cat) && p.img && p.available).slice(0, lim);
    }
    if (!list.length) return;
    const track = rail.querySelector('[data-rail-track]');
    const html = list.map(card).join('');

    /* SUR TELEPHONE : PAS DE RUBAN QUI DEFILE.
       Un ruban en mouvement continu a, a chaque instant, une carte tranchee
       a gauche et une a droite : on lisait « t Amsterdam » et « ENTS ».
       Mesure : 20 % et 38 % de produit visible. Or aucune image ne doit
       jamais etre coupee.
       Le doigt sait deja faire defiler : on rend donc la main au scroll
       natif, avec un point d'arret par produit (CSS, scroll-snap). Chaque
       carte s'arrete entiere. On ne duplique pas la liste non plus, la
       boucle sans couture n'ayant de sens que pour un defilement continu. */
    const auDoigt = matchMedia('(max-width: 760px)').matches;
    if (auDoigt) {
      track.innerHTML = html;
      rail.classList.add('rail--tactile');
      return;
    }

    track.innerHTML = html + html; // duplication = boucle sans couture
    let offset = 0, half = 0, paused = false, dragging = false, startX = 0, startOff = 0, moved = 0;
    const SPEED = 0.45, dir = parseInt(rail.dataset.dir || '1', 10);
    const measure = () => { half = track.scrollWidth / 2; };
    measure();
    addEventListener('resize', measure, { passive: true });
    const apply = () => {
      if (offset <= -half) offset += half;
      if (offset > 0) offset -= half;
      track.style.transform = `translate3d(${offset}px,0,0)`;
    };
    rail.addEventListener('pointerenter', () => { if (!dragging) paused = true; });
    rail.addEventListener('pointerleave', () => { if (!dragging) paused = false; });
    rail.addEventListener('pointerdown', e => { dragging = true; paused = true; startX = e.clientX; startOff = offset; moved = 0; track.classList.add('dragging'); try { rail.setPointerCapture(e.pointerId); } catch (_) {} });
    rail.addEventListener('pointermove', e => { if (!dragging) return; const dx = e.clientX - startX; moved = Math.max(moved, Math.abs(dx)); offset = startOff + dx; apply(); });
    const end = () => { if (!dragging) return; dragging = false; track.classList.remove('dragging'); setTimeout(() => { paused = false; }, 600); };
    rail.addEventListener('pointerup', end);
    rail.addEventListener('pointercancel', end);
    rail.addEventListener('click', e => { if (moved > 6) { e.preventDefault(); e.stopPropagation(); } }, true); // anti-clic-après-drag
    const loop = () => { if (!paused && !reduce) { offset -= SPEED * dir; apply(); } requestAnimationFrame(loop); };
    if (!reduce) requestAnimationFrame(loop); else apply();
  });

  /* ---------- PANIER (persisté entre pages et sessions) ---------- */
  /* Le seuil de livraison offerte, lu sur le marqueur du theme. A 0, la
     livraison est offerte sans minimum et le bloc de suggestions ne
     s'affiche plus : il n'y a plus d'ecart a combler. */
  const FREE = (() => { const e = document.querySelector('[data-ship-msg]');
    return e ? parseInt(e.dataset.seuil || '0', 10) / 100 : 0; })();
  const CART_KEY = 'fn_cart_v1';
  /* Panier local de la V2 : conserve VIDE. On efface aussi ce qui trainait
     dans le navigateur des visiteurs, sans quoi de vieilles lignes fantomes
     reapparaissaient dans le tiroir a cote du vrai panier Shopify. */
  let cart = [];
  try { localStorage.removeItem(CART_KEY); } catch (_) {}
  const els = {
    count: $$('[data-cart-count]'), countTxt: $('[data-cart-count-txt]'),
    items: $('[data-cart-items]'), empty: $('[data-cart-empty]'),
    sub: $('[data-cart-sub]'), shipMsg: $('[data-ship-msg]'), shipBar: $('[data-ship-bar]'),
    ship: $('.drawer__ship'), drawer: $('[data-cart]'), backdrop: $('[data-cart-backdrop]'),
  };
  const find = h => PRODUCTS.find(p => p.handle === h);

  /* ---------- LE PANIER SE RECONFRONTE AU CATALOGUE ----------
     Une ligne de panier etait un instantane : prix, titre, image et categorie
     etaient recopies au moment de l'ajout, puis relus tels quels a chaque
     visite. Un panier abandonne trois semaines rouvrait donc avec l'ancien
     prix — et c'est ce prix-la que le client voyait au moment de payer.
     Baisse de tarif : on perd de l'argent. Hausse : on affiche un prix qu'on
     ne pratique plus. Renommage : le client ne reconnait plus sa piece.

     A chaque chargement, on realigne donc chaque ligne sur le catalogue, seule
     source de verite. La piece personnalisee (`cap-perso`) n'y figure pas :
     elle garde ses valeurs, c'est le seul cas legitime. Une piece disparue du
     catalogue sort du panier — mieux vaut une ligne en moins qu'une commande
     impossible a honorer. */
  (function realignerSurLeCatalogue() {
    if (!PRODUCTS.length) return;          // catalogue pas encore la : on ne touche a rien
    let change = false;
    cart = cart.filter(l => {
      if (l.handle === 'cap-perso') return true;
      const p = find(l.handle);
      if (!p) { change = true; return false; }
      if (l.price !== p.price || l.title !== p.title || l.img !== p.img || l.cat !== p.cat) {
        l.price = p.price; l.title = p.title; l.img = p.img; l.cat = p.cat;
        change = true;
      }
      if (p.available === false) { change = true; return false; }
      return true;
    });
    if (change) { try { localStorage.setItem(CART_KEY, JSON.stringify(cart)); } catch (_) {} }
  })();
  const T = () => window.FN_TRACK; // couche tracking (facultative : le site marche sans)

  /* ---------- GAP-FILLER livraison offerte ----------
     DESACTIVE depuis que la livraison est offerte SANS MINIMUM (2026-10-07) :
     il n'y a plus d'ecart a combler, et proposer d'ajouter une piece « pour
     la livraison offerte » serait un argument faux. Le bloc est conserve,
     il se rallumera tout seul si un seuil est reintroduit.
     Quand il manque X € pour franchir le seuil reel, proposer 1-2 pieces
     dont le prix comble l'ecart (casquettes en premier : ajout en 1 clic, taille
     unique). Aucun prix ni remise inventes : on ne fait que reutiliser le seuil. */
  const GAP_POOL = [
    'casquette-noire-ajustable-style-trucker-fraise-noire-2023', // Classics Black 39,90
    'casquette-ajustable-classics-blue-navy',                    // Classics Blue Navy 39,90
    'short-de-bain-rouge',                                       // 34,90
    't-shirt-king-panda-fraise-noire-2023',                      // 39,90
    't-shirt-the-ruche-blanc',                                   // 49,90
    'casquette-brodee-3d-ajustable-black',                       // 54,90
  ];
  let gapEl = null;
  function gapFill(sub) {
    if (!gapEl) {
      const ship = els.ship || (els.shipMsg && els.shipMsg.closest('.drawer__ship'));
      if (!ship) return;
      gapEl = document.createElement('div');
      gapEl.className = 'drawer__gap';
      gapEl.hidden = true;
      ship.insertAdjacentElement('afterend', gapEl);
    }
    const remain = FREE - sub;
    const lignes = lignesPanier();
    /* `FREE <= 0` : livraison offerte sans minimum, il n'y a rien a combler. */
    if (!FREE || !lignes.length || remain <= 0) { gapEl.innerHTML = ''; gapEl.hidden = true; return; }
    const inCart = new Set(lignes.map(l => l.handle));
    const pool = GAP_POOL.map(find).filter(p => p && p.available && p.img && !inCart.has(p.handle));
    let picks = pool.filter(p => p.price >= remain).sort((a, b) => a.price - b.price).slice(0, 2);
    const crosses = picks.length > 0;
    if (!picks.length) picks = pool.slice(0, 2);
    if (!picks.length) { gapEl.innerHTML = ''; gapEl.hidden = true; return; }
    gapEl.hidden = false;
    gapEl.innerHTML = `<p class="drawer__gap-lbl">${crosses ? 'Ajoute une pièce, la livraison est offerte :' : 'Pour te rapprocher de la livraison offerte :'}</p>` +
      picks.map(p => `
      <div class="gapitem">
        <a class="gapitem__media" href="${p.url || "/products/" + p.handle}">${media(p.img, `alt="${att(p.title)}" loading="lazy"`, "(max-width:760px) 45vw, 22vw")}</a>
        <div class="gapitem__txt"><span class="gapitem__name">${esc(p.title)}</span><span class="gapitem__price tabular">${eur(p.price)}</span></div>
        ${(p.sizes && p.sizes.length)
          ? `<a class="gapitem__btn" href="${p.url || "/products/" + p.handle}">Choisir</a>`
          : `<button class="gapitem__btn" data-add="${p.handle}">Ajouter</button>`}
      </div>`).join('');
  }
  /* Ajout au panier — passe TOUJOURS par le panier Shopify.
     La V2 empilait les lignes dans un tableau local et un localStorage. Sur la
     boutique, ce panier-la n'est vu par personne : « Ajouter le duo » affichait
     « ajoute », remplissait le tiroir, et le panier du serveur restait vide. Le
     client arrivait au paiement les mains vides.
     Les ajouts sont mis a la queue : deux pieces d'un duo partent l'une apres
     l'autre, jamais en meme temps. */
  let fileAjout = Promise.resolve();
  function addToCart(handle, size) {
    const p = find(handle); if (!p) return fileAjout;
    fileAjout = fileAjout.then(async () => {
      if (!window.FN_CART) { location.href = '/products/' + handle; return; }
      try {
        await FN_CART.ajouter(handle, size || '');
        T() && T().addToCart(p, size, 1);
        toast(`${p.title} ${size ? '· ' + size : ''} ajouté`);
      } catch (_) {
        toast("Cette pièce n'a pas pu être ajoutée.");
      }
    }).catch(() => {});
    return fileAjout;
  }
  /* Casquette personnalisable.
     Version V2 : la ligne etait poussee dans un panier local. Sur Shopify, ce
     panier n'existe plus — le bouton affichait « ajoutee », ouvrait le tiroir,
     et le panier du serveur restait vide. Le client croyait avoir commande.

     Ici : si la piece est reellement en vente (window.FN_PERSO, pose par le
     theme), on l'ajoute au VRAI panier avec la configuration en proprietes de
     ligne, pour que l'atelier sache quoi poser. Sinon on ne pretend rien :
     on emmene le client vers la commande sur mesure, configuration en main. */
  async function addCustom(item) {
    const P = window.FN_PERSO;
    /* La COULEUR CHOISIE decide de la variante. Avant, on prenait la premiere
       variante disponible : le client composait une abeille rose et recevait
       « Orange » dans son panier, parce qu'Orange est la premiere de la liste
       (signale par Hedy le 2026-10-07). La couleur n'etait transmise que dans
       la note, donc invisible pour le choix de la ligne.
       Sans correspondance (une teinte proposee mais pas encore creee cote
       catalogue), on NE met rien dans le panier : on bascule sur la commande
       sur mesure plus bas, plutot que de vendre la mauvaise couleur. */
    const sansAccent = s => String(s || '').normalize('NFD').replace(/[̀-ͯ]/g, '').trim().toLowerCase();
    const variantes = (P && P.variants || []).filter(v => v.dispo);
    const dispo = item.couleur
      ? variantes.find(v => sansAccent(v.titre) === sansAccent(item.couleur))
      : variantes[0];

    if (dispo) {
      try {
        const r = await fetch((window.FN_SHOP && FN_SHOP.routes.cartAdd) || '/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: dispo.id, quantity: 1, properties: { 'Personnalisation': item.note || '' } }] })
        });
        if (!r.ok) throw new Error('ajout refuse');
        if (window.FN_CART) { await FN_CART.relire(); FN_CART.ouvrir(); }
        T() && T().addToCart({ handle: P.handle, title: item.title, cat: 'Personnalisation', price: item.price }, null, 1);
        toast((item.title || 'Pièce') + ' ajoutée');
      } catch (_) {
        toast("Cette pièce n'a pas pu être ajoutée.");
      }
      return;
    }

    /* Pas de piece en vente : commande sur mesure. On passe la configuration au
       formulaire de contact, qui la pre-remplit. */
    T() && T().custom && T().custom('perso_sur_mesure', { note: item.note || '' });
    location.href = '/pages/contact?config=' + encodeURIComponent(item.note || 'Casquette personnalisable');
  }
  /* Le tiroir, le compteur et la barre de livraison offerte sont rendus par
     fn-panier.js a partir du panier Shopify. Cette fonction ne garde que ce qui
     lui appartient : les suggestions « complete ton panier ». Avant, elle
     reecrivait le tiroir avec le panier local et faisait reapparaitre des
     lignes fantomes restees dans le localStorage. */
  /* Le panier Shopify, relu au format du catalogue (handle / cat / prix en
     euros), pour les deux blocs de suggestion ci-dessous. */
  function lignesPanier() {
    const p = (window.FN_CART && FN_CART.get()) || null;
    if (!p || !p.items) return [];
    return p.items.map(l => {
      const c = find(l.handle) || {};
      return { handle: l.handle, qty: l.quantity, price: (l.final_line_price || 0) / 100 / (l.quantity || 1), cat: c.cat || '' };
    });
  }

  function renderCart() {
    const p = (window.FN_CART && FN_CART.get()) || { total_price: 0 };
    gapFill((p.total_price || 0) / 100);
  }
  document.addEventListener('fn:panier', renderCart);

  let lastFocus = null;
  function openCart() { if (!els.drawer) { location.href = '/cart'; return; } lastFocus = document.activeElement; els.drawer.classList.add('open'); els.drawer.setAttribute('aria-hidden', 'false'); els.drawer.removeAttribute('inert'); els.backdrop.hidden = false; requestAnimationFrame(() => els.backdrop.classList.add('show')); const c = els.drawer.querySelector('[data-cart-close]'); c && c.focus(); }
  function closeCart() { if (!els.drawer) return; els.drawer.classList.remove('open'); els.drawer.setAttribute('aria-hidden', 'true'); els.drawer.setAttribute('inert', ''); els.backdrop.classList.remove('show'); setTimeout(() => els.backdrop.hidden = true, 450); lastFocus && lastFocus.focus && lastFocus.focus(); }
  els.drawer && els.drawer.setAttribute('inert', '');

  document.addEventListener('click', e => {
    const add = e.target.closest('[data-add]');
    if (add) { e.preventDefault(); addToCart(add.dataset.add, add.dataset.size); return; }
    const wish = e.target.closest('.card__wish');
    if (wish) {
      e.preventDefault(); const on = wish.classList.toggle('is-on'); wish.style.color = on ? 'var(--fraise)' : '';
      const wcard = wish.closest('.card');
      const wa = wcard && wcard.querySelector('.card__link');
      const wh = wa ? new URLSearchParams(wa.getAttribute('href').split('?')[1] || '').get('handle') : null;
      const wp = wh && find(wh); if (wp && T()) T().wishlist(wp, on);
      toast(on ? 'Ajouté aux favoris' : 'Retiré des favoris'); return;
    }
    if (e.target.closest('[data-search]')) { T() && T().searchIntent && T().searchIntent('header'); if (window.FN_SEARCH) { window.FN_SEARCH.open(); } return; }
    if (e.target.closest('[data-cart-open]')) { openCart(); return; }
    if (e.target.closest('[data-cart-close]') || e.target.closest('[data-cart-backdrop]')) { closeCart(); return; }
    /* Les quantites du tiroir sont gerees par fn-panier.js, qui adresse chaque
       ligne par sa cle Shopify (data-ligne). Les anciens gestionnaires visaient
       un index dans le tableau local : ils modifiaient la mauvaise ligne des
       qu'une autre disparaissait. */
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeCart(); });
  renderCart();

  /* ---------- « COMPLÉTEZ LE LOOK » (page panier) ----------
     4 pieces disponibles complementaires aux categories du panier,
     jamais deja dans le panier. Rendu une fois au chargement. */
  const crWrap = $('[data-cart-related-wrap]'), crGrid = $('[data-cart-related]');
  const lignesCR = lignesPanier();
  if (crWrap && crGrid && lignesCR.length) {
    const CART_RULES = {
      't-shirt': ['Casquettes', 'Shorts', 'Hoodies'],
      'Shorts': ['t-shirt', 'Casquettes'],
      'Hoodies': ['Casquettes', 't-shirt'],
      'Casquettes': ['t-shirt', 'Shorts', 'Hoodies'],
      'Ensembles': ['Casquettes', 't-shirt'],
      'Survêtements': ['Casquettes', 't-shirt'],
    };
    const pref = [];
    lignesCR.forEach(l => (CART_RULES[l.cat] || []).forEach(k => { if (!pref.includes(k)) pref.push(k); }));
    ['Casquettes', 't-shirt', 'Hoodies', 'Shorts'].forEach(k => { if (!pref.includes(k)) pref.push(k); });
    const used = new Set(lignesCR.map(l => l.handle));
    const picks = [];
    for (let pass = 0; pass < 4 && picks.length < 4; pass++) {
      for (const k of pref) {
        if (picks.length >= 4) break;
        const c = PRODUCTS.find(p => p.available && p.img && matchCat(p, k) && !used.has(p.handle));
        if (c) { picks.push(c); used.add(c.handle); }
      }
    }
    if (picks.length) { crGrid.innerHTML = picks.map(card).join(''); crWrap.hidden = false; }
  }

  /* ---------- NEWSLETTER — capture réelle (pré-Shopify) ----------
     Chaque inscription est CONSERVÉE : stockage local persistant (clé NEWS_KEY,
     dédoublonné, horodaté) + envoi vers un endpoint si configuré
     (window.FN_NEWSLETTER_ENDPOINT ou attribut action du formulaire —
     à brancher sur Shopify/Klaviyo/Formspree au portage).
     Export pour Hedy : window.FN.newsletterExport() (telecharge un CSV)
     ou window.FN.newsletterList() dans la console. */
  const NEWS_KEY = 'fn_newsletter_v1';
  function newsRead() { try { const s = JSON.parse(localStorage.getItem(NEWS_KEY)); return Array.isArray(s) ? s : []; } catch (_) { return []; } }
  function newsSave(email) {
    const norm = String(email || '').trim().toLowerCase();
    if (!norm) return false;
    const list = newsRead();
    if (!list.some(x => x && x.email === norm)) list.push({ email: norm, date: new Date().toISOString(), source: 'newsletter_footer', page: location.pathname });
    try { localStorage.setItem(NEWS_KEY, JSON.stringify(list)); return true; } catch (_) { return false; }
  }
  function newsExport() {
    const list = newsRead();
    const csv = 'email;date;source;page\n' + list.map(x => [x.email, x.date, x.source, x.page].map(v => String(v == null ? '' : v).replace(/;/g, ',')).join(';')).join('\n');
    const a = document.createElement('a');
    a.href = URL.createObjectURL(new Blob([csv], { type: 'text/csv;charset=utf-8' }));
    a.download = 'fraise-noire-newsletter.csv';
    document.body.appendChild(a); a.click(); a.remove();
    setTimeout(() => URL.revokeObjectURL(a.href), 1000);
    return list.length + ' inscription(s) exportée(s)';
  }
  const news = $('[data-news]');
  const NEWS_ENDPOINT = window.FN_NEWSLETTER_ENDPOINT || (news && news.getAttribute('action')) || '';
  news && news.addEventListener('submit', e => {
    e.preventDefault();
    const i = news.querySelector('input');
    if (!(i && i.checkValidity())) { i && i.reportValidity(); return; }
    const email = i.value;
    const stored = newsSave(email);
    if (NEWS_ENDPOINT) {
      try { fetch(NEWS_ENDPOINT, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ email: email.trim().toLowerCase(), source: 'newsletter_footer', page: location.pathname }) }).catch(() => {}); } catch (_) {}
    }
    if (stored || NEWS_ENDPOINT) {
      T() && T().signUp('newsletter_footer');
      /* ON NE PROMET QUE CE QU'ON PEUT TENIR.
         Sans endpoint, l'adresse ne quitte pas le navigateur du visiteur :
         personne ne la recevra, donc aucun code ne partira. Annoncer le
         contraire, c'est une promesse intenable faite au premier contact —
         exactement le genre de detail qui coute la confiance d'un client qui
         s'apprete a confier sa carte. Des que `action` est renseigne sur le
         formulaire (voir /), le message complet revient de lui-meme. */
      toast(NEWS_ENDPOINT
        ? 'Bienvenue dans le cercle — ton code −10 % arrive à l\'ouverture de la boutique en ligne.'
        : 'C\'est noté — on te prévient dès l\'ouverture de la boutique en ligne.');
      news.reset();
    } else {
      /* Stockage impossible (navigation privée…) et pas d'endpoint : pas de fausse promesse. */
      toast('Impossible d\'enregistrer ton email sur cet appareil — écris-nous à info@fraisenoire.com pour rejoindre le cercle.');
    }
  });

  /* ---------- TOAST ---------- */
  let tt;
  const toastEl = $('[data-toast]');
  function toast(msg) {
    if (!toastEl) return;
    toastEl.innerHTML = `<svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="#7DF1AE" stroke-width="2"><path d="m5 13 4 4L19 7"/></svg><span>${esc(msg)}</span>`;
    toastEl.hidden = false; requestAnimationFrame(() => toastEl.classList.add('show'));
    clearTimeout(tt); tt = setTimeout(() => { toastEl.classList.remove('show'); setTimeout(() => toastEl.hidden = true, 280); }, 2400);
  }

  /* ---------- NAV hide-on-scroll ---------- */
  const nav = $('#nav'); let lastY = 0;
  addEventListener('scroll', () => {
    const y = scrollY;
    if (y > 200 && y > lastY) nav.classList.add('nav--hidden'); else nav.classList.remove('nav--hidden');
    lastY = y;
  }, { passive: true });

  /* ---------- BURGER (mobile) : menu plein écran construit au 1er clic ---------- */
  const burger = $('.nav__burger');
  let mnav = null;
  function buildMobileMenu() {
    mnav = document.createElement('div');
    mnav.className = 'mnav';
    mnav.setAttribute('role', 'dialog');
    mnav.setAttribute('aria-label', 'Menu');
    mnav.innerHTML = `
      <nav class="mnav__links" aria-label="Catégories">
        <a href="/collections/all">Toute la boutique</a>
        <div class="mnav__groupe">
          <a href="/collections/casquettes">Casquettes</a>
          <button class="mnav__plus" type="button" aria-expanded="false" aria-controls="mnav-casq" aria-label="Voir les familles de casquettes">
            <svg viewBox="0 0 24 24" width="22" height="22" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 9l6 6 6-6"/></svg>
          </button>
        </div>
        <!-- 20/10/2026 — trois corrections sur ce menu, qui sert 95 % du trafic :
             · « Jogging » y manquait, alors qu'il est au menu bureau et au pied ;
             · « Hoodies » pointait sur /collections/sweats, une collection qui
               N'EXISTE PAS : le lien ne marchait que grâce à une redirection
               posée à la main dans l'admin. La supprimer cassait le menu, sans
               que rien ne le signale nulle part ;
             · « Casquette personnalisée » faisait un saut de redirection de
               plus. Les deux pointent désormais sur la vraie collection. -->
        <div class="mnav__sous" id="mnav-casq" hidden>
          <a href="/collections/casquettes-brodees-3d">Casquettes brodées 3D</a>
          <a href="/collections/casquettes-classics">Casquettes Classics</a>
          <a href="/collections/casquettes-lettrees">Casquettes lettrées</a>
          <a href="/collections/casquettes-abeille">Casquettes Abeille</a>
          <a href="/collections/casquettes-personnalisables-1">Casquette personnalisée</a>
        </div>
        <a href="/collections/t-shirt">T-shirts</a>
        <a href="/collections/hoodies">Hoodies</a>
        <a href="/collections/ensembles">Ensembles</a>
        <a href="/collections/survetements">Survêtements</a>
        <a href="/collections/jogging">Jogging</a>
        <a href="/collections/shorts">Shorts</a>
      </nav>
      <nav class="mnav__second" aria-label="La maison">
        <a href="/pages/histoire">L'histoire</a>
        <a href="/pages/aide">Aide &amp; FAQ</a>
        <a href="/cart">Panier</a>
      </nav>
      <p class="mnav__seal label">◖&nbsp;Scellé à Marseille&nbsp;◗</p>`;
    document.body.appendChild(mnav);
    /* Le chevron ouvre les familles de casquettes. Le nom reste un LIEN : un
       client qui tape « Casquettes » va voir tout le rayon, comme avant. Seul
       le chevron deplie — sans cela, on perdrait l'acces au rayon entier. */
    const plus = mnav.querySelector('.mnav__plus');
    const sous = mnav.querySelector('.mnav__sous');
    if (plus && sous) {
      plus.addEventListener('click', e => {
        e.preventDefault(); e.stopPropagation();
        const ouvert = !sous.hidden;
        sous.hidden = ouvert;
        plus.setAttribute('aria-expanded', String(!ouvert));
        plus.classList.toggle('est-ouvert', !ouvert);
      });
    }
    mnav.addEventListener('click', e => { if (e.target.closest('a')) closeMenu(); });
  }
  /* La reserve en haut du menu doit valoir la barre reelle : bandeau d'annonce
     compris quand il est actif, rien quand il est coupe depuis l'admin. On la
     mesure a chaque ouverture plutot que de la figer dans le CSS. */
  function mesurerBarre() {
    const barre = document.querySelector('.nav') || document.querySelector('header');
    if (!barre) return;
    const bas = Math.round(barre.getBoundingClientRect().bottom);
    if (bas > 0) document.documentElement.style.setProperty('--h-nav', bas + 'px');
  }
  function openMenu() { if (!mnav) buildMobileMenu(); mesurerBarre(); burger.setAttribute('aria-expanded', 'true'); document.body.classList.add('menu-open'); }
  function closeMenu() { burger && burger.setAttribute('aria-expanded', 'false'); document.body.classList.remove('menu-open'); }
  burger && burger.addEventListener('click', () => {
    document.body.classList.contains('menu-open') ? closeMenu() : openMenu();
  });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeMenu(); });


  /* ---------- VIDEOS LAZY (8 Mo : chargées à l'approche seulement) ---------- */
  const lazyVids = $$('[data-lazy-video]');

  /* L'AFFICHE AUSSI EST DIFFEREE.
     `preload="none"` ne couvre que le flux video : l'attribut `poster`, lui, se
     telecharge immediatement. L'affiche du film (197 Ko) partait donc au
     chargement pour une video situee huit ecrans plus bas, et volait la bande
     passante a l'image principale. On la porte en `data-poster` et on la pose a
     l'approche — 600 px avant, soit largement le temps qu'elle arrive. */
  const poserAffiche = v => { if (v.dataset.poster && !v.poster) { v.poster = v.dataset.poster; } };
  if ('IntersectionObserver' in window) {
    const aio = new IntersectionObserver(es => es.forEach(e => {
      if (!e.isIntersecting) return;
      poserAffiche(e.target); aio.unobserve(e.target);
    }), { rootMargin: '600px 0px' });
    $$('[data-poster]').forEach(v => aio.observe(v));
  } else {
    $$('[data-poster]').forEach(poserAffiche);
  }

  /* Mouvement réduit : on ne lance rien et on ne télécharge pas la vidéo.
     L'affiche, elle, reste posée par l'observateur ci-dessus — elle dit la
     même chose, sans bouger. */
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) {
    lazyVids.length = 0;
  }
  /* Quelle variante télécharger ? Sur un téléphone, la 720p est deux fois
     trop lourde pour un cadre de 390 px : 2 045 815 octets contre 899 681.
     On lit la largeur AU MOMENT du chargement, pas au chargement du script,
     parce que la vidéo n'arrive qu'au scroll et que l'écran a pu tourner. */
  const sourceVideo = v =>
    (v.dataset.lazyVideoSd && innerWidth < 900) ? v.dataset.lazyVideoSd : v.dataset.lazyVideo;

  if (lazyVids.length && 'IntersectionObserver' in window) {
    const vio = new IntersectionObserver(entries => {
      entries.forEach(en => {
        if (!en.isIntersecting) return;
        const v = en.target;
        if (!v.src) { v.src = sourceVideo(v); v.play && v.play().catch(() => {}); }
        vio.unobserve(v);
      });
    }, { rootMargin: '600px 0px' });
    lazyVids.forEach(v => vio.observe(v));
  } else {
    lazyVids.forEach(v => { v.src = sourceVideo(v); });
  }

  /* ---------- LENIS + GSAP ---------- */
  let lenis;
  if (!reduce && !touch && window.Lenis) {
    lenis = new Lenis({ duration: 1.1, easing: t => Math.min(1, 1.001 - Math.pow(2, -10 * t)), smoothWheel: true });
    const raf = t => { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    // sync avec ScrollTrigger (sections épinglées)
    if (window.ScrollTrigger) lenis.on('scroll', () => ScrollTrigger.update());
  }
  // Hero parallax via GSAP (decoratif uniquement)
  if (window.gsap && window.ScrollTrigger && !reduce) {
    gsap.registerPlugin(ScrollTrigger);
    if (lenis) lenis.on('scroll', ScrollTrigger.update);
    const heroImg = $('.hero__img');
    if (heroImg) gsap.to(heroImg, { yPercent: 12, ease: 'none', scrollTrigger: { trigger: '.hero', start: 'top top', end: 'bottom top', scrub: true } });
  }
  // Reveals : hero animé au load (stagger GSAP), le reste en IntersectionObserver
  const heroReveals = $$('.hero [data-reveal]');
  const rest = $$('[data-reveal]').filter(el => !el.closest('.hero'));
  if (reduce || !('IntersectionObserver' in window)) {
    $$('[data-reveal]').forEach(el => el.classList.add('is-in'));
  } else {
    // Hero : entrée séquencée au chargement
    if (window.gsap && heroReveals.length) {
      gsap.set(heroReveals, { opacity: 0, y: 20 });
      gsap.to(heroReveals, { opacity: 1, y: 0, duration: .95, stagger: .12, ease: 'power3.out', delay: .15 });
    } else { heroReveals.forEach(el => el.classList.add('is-in')); }
    // Reste : révélé au scroll
    const io = new IntersectionObserver(es => es.forEach(en => { if (en.isIntersecting) { en.target.classList.add('is-in'); io.unobserve(en.target); } }), { rootMargin: '0px 0px -8% 0px', threshold: 0.1 });
    rest.forEach(el => io.observe(el));
    /* LE FILET NE DOIT PAS REMPLACER LE SYSTEME QU'IL PROTEGE.
       Il revelait TOUS les blocs 2,5 s apres le chargement : passe ce delai,
       l'observateur n'avait plus rien a observer et la revelation au defilement
       n'existait plus — les vingt blocs de la page arrivaient deja montres.
       Le filet garde son role — aucun contenu ne doit dependre d'une animation
       pour exister — mais il ne se declenche que la ou l'observateur ne peut
       pas aider : d'abord ce qui est deja a l'ecran, puis, tres tard, le reste,
       au cas ou l'observateur aurait echoue. */
    const dejaVisible = el => {
      const r = el.getBoundingClientRect();
      return r.top < innerHeight * 1.1;
    };
    setTimeout(() => rest.forEach(el => { if (dejaVisible(el)) el.classList.add('is-in'); }), 1200);
    setTimeout(() => rest.forEach(el => el.classList.add('is-in')), 12000);
  }

  // Vidéo : couper l'autoplay si mouvement réduit
  if (reduce) { const v = $('.story__video'); if (v) { v.removeAttribute('autoplay'); v.pause && v.pause(); } }

  // ---------- COMPARATEURS À CURSEUR (face/dos, casquette…) ----------
  $$('[data-fd]').forEach(fd => {
    const fdHandle = $('[data-fd-handle]', fd);
    const setX = x => { x = Math.max(4, Math.min(96, x)); fd.style.setProperty('--x', x + '%'); if (fdHandle) fdHandle.setAttribute('aria-valuenow', Math.round(x)); };
    let fdDrag = false;
    const fdFrom = e => { const r = fd.getBoundingClientRect(); return ((e.clientX - r.left) / r.width) * 100; };
    fd.addEventListener('pointerdown', e => { fdDrag = true; try { fd.setPointerCapture(e.pointerId); } catch (_) {} setX(fdFrom(e)); });
    fd.addEventListener('pointermove', e => { if (fdDrag) setX(fdFrom(e)); });
    const fdUp = () => { fdDrag = false; };
    fd.addEventListener('pointerup', fdUp); fd.addEventListener('pointercancel', fdUp);
    if (fdHandle) fdHandle.addEventListener('keydown', e => { const cur = parseFloat(fd.style.getPropertyValue('--x')) || 50; if (e.key === 'ArrowLeft') { setX(cur - 4); e.preventDefault(); } if (e.key === 'ArrowRight') { setX(cur + 4); e.preventDefault(); } });
  });

  // ---------- CASQUETTE PERSONNALISABLE (couleur de l'abeille, fidèle au site) ----------
  const beeImg = $('[data-bee-img]'), beeColors = $('[data-bee-colors]');
  if (beeImg && beeColors) {
    // Six teintes : celles que l'atelier brode reellement. Noire, rouge, grise
    // et marron ont ete retirees le 2026-10-03 — ne pas les reintroduire sans
    // que la piece existe.
    // Pas de « ?v= » ajoute ici : une URL d'asset Shopify en porte deja un
    // (?v=<empreinte>), et un second point d'interrogation la casserait.
    const IMG = {
      bleue: FN_A('studio-bleue.jpg'), orange: FN_A('studio-orange.jpg'),
      jaune: FN_A('studio-jaune.jpg'), vert: FN_A('studio-vert.jpg'),
      rose: FN_A('studio-rose.jpg'), violet: FN_A('studio-violet.jpg')
    };
    const LBL = {
      bleue: 'bleue', orange: 'orange', jaune: 'jaune',
      vert: 'verte', rose: 'rose', violet: 'violette'
    };
    let bee = 'bleue';
    // La photo est servie par un <picture> : tant que le <source> webp reste
    // sur la bleue, changer le src de l'<img> ne change RIEN a l'ecran — le
    // navigateur garde la source webp. On deplace les deux ensemble.
    const beeSrc = beeImg.parentNode && beeImg.parentNode.querySelector('source');
    const poserAbeille = c => {
      if (!IMG[c]) return;
      if (beeSrc) {
        beeSrc.srcset = FN_A(`studio-${c}-600.webp`) + ' 600w, ' + FN_A(`studio-${c}-1200.webp`) + ' 1200w';
      }
      beeImg.src = IMG[c];
    };
    beeColors.addEventListener('click', e => {
      const b = e.target.closest('[data-bee]'); if (!b) return;
      bee = b.dataset.bee; poserAbeille(bee);
      $$('.beeopt', beeColors).forEach(x => x.classList.toggle('is-on', x === b));
    });
    const addBtn = $('[data-bee-add]');
    addBtn && addBtn.addEventListener('click', () => {
      const txt = ($('[data-cap-input]') && $('[data-cap-input]').value || '').trim();
      const col = LBL[bee] || bee;
      const note = txt ? `Flex « ${txt} » · abeille ${col}` : `Logo abeille ${col}`;
      /* `couleur` porte le libelle du catalogue (« rose », « verte »…) : c'est
         lui qui choisit la variante. La note reste pour l'atelier. */
      addCustom({ handle: 'cap-perso', title: 'Casquette personnalisable', price: 59.9, img: IMG[bee] || beeImg.src, note, couleur: col });
    });
  }

  // ---------- LOOKBOOK SHOPPABLE (hotspots) ----------
  /* Une scene = une photo + ses pastilles + SA fiche. Il y en a desormais deux
     (le lookbook et la photo de campagne de la section « L'origine ») : on
     boucle donc sur les scenes au lieu de prendre la premiere fiche de la page,
     sinon les pastilles de la seconde ouvriraient la fiche de la premiere. */
  $$('[data-look-pop]').forEach(pop => {
    const scene0 = pop.closest('.look__stage') || pop.parentElement;
    const dots = $$('.look__dot', scene0);
    let openDot = null;
    const closePop = () => { pop.classList.remove('show'); setTimeout(() => { pop.hidden = true; }, 280); dots.forEach(d => d.classList.remove('is-active')); openDot = null; };
    dots.forEach(dot => dot.addEventListener('click', e => {
      e.stopPropagation();
      const pr = find(dot.dataset.look); if (!pr) return;
      if (openDot === dot) { closePop(); return; }
      dots.forEach(d => d.classList.toggle('is-active', d === dot));
      pop.innerHTML = `${media(pr.img, `alt=""`, "120px")}<div class="look__pop-name">${esc(pr.title)}</div><div class="look__pop-row"><span class="look__pop-price tabular">${eur(pr.price)}</span><button class="btn btn--solid" data-add="${att(pr.handle)}">Ajouter</button></div>`;
      /* La position est lue sur le style CALCULE : les pastilles de la section
         « L'origine » la tiennent de variables CSS qui basculent entre le
         cadrage vertical et le panoramique. `dot.style.left` serait vide. */
      const cs = getComputedStyle(dot);
      const largeurRef = (dot.offsetParent || dot.parentElement).clientWidth || 1;
      const hauteurRef = (dot.offsetParent || dot.parentElement).clientHeight || 1;
      const enPct = (v, ref) => v.endsWith('%') ? parseFloat(v) : (parseFloat(v) / ref) * 100;
      const leftPct = enPct(cs.left, largeurRef), topPct = enPct(cs.top, hauteurRef);
      pop.hidden = false;
      /* LA FICHE DOIT RESTER DANS LA SCENE, QUELLE QUE SOIT LA LARGEUR.
         Les bornes etaient en pourcentage (14 % / 86 %) alors que la fiche a
         une largeur FIXE de 240 px et qu'elle est centree sur le point. Sur un
         telephone de 390 px, 86 % place son bord droit 45 px hors de l'ecran :
         le prix et le bouton « Ajouter » deviennent inatteignables, sur la
         seule section ou l'on achete en un geste.
         On borne donc en pixels, a partir des largeurs reelles, et on bascule
         la fiche AU-DESSUS du point quand il n'y a plus la place dessous. */
      const scene = pop.offsetParent || pop.parentElement;
      const largeurScene = scene.clientWidth, hauteurScene = scene.clientHeight;
      const demi = pop.offsetWidth / 2, marge = 10;
      const xVoulu = leftPct / 100 * largeurScene;
      const xBorne = Math.max(demi + marge, Math.min(largeurScene - demi - marge, xVoulu));
      pop.style.left = xBorne + 'px';

      const yPoint = topPct / 100 * hauteurScene;
      const h = pop.offsetHeight;
      const hautScene = scene.getBoundingClientRect().top;

      /* 1. Place voulue : sous le point, sinon au-dessus s'il n'y a pas la
            place dans la scene. */
      let top = yPoint + 26;
      if (h + 2 * marge <= hauteurScene && top + h > hauteurScene - marge) {
        top = yPoint - 26 - h;
      }
      /* 2. La fiche reste dans la scene quand celle-ci est assez haute. */
      if (h + 2 * marge <= hauteurScene) {
        top = Math.max(marge, Math.min(top, hauteurScene - h - marge));
      }
      /* 3. ET SURTOUT dans l'ECRAN — ce bornage vient en DERNIER, il prime.
            Sans lui, une fiche posee dans une scene haute (la photo de
            campagne fait 749 px) sortait par le bas de l'ecran sur un
            telephone de 390 px : le bouton « Ajouter » devenait inatteignable,
            alors que c'est tout l'interet de la pastille (defaut vu le
            2026-10-07, mesure a 870 px pour un ecran de 844). */
      const minEcran = marge - hautScene;
      const maxEcran = innerHeight - hautScene - h - marge;
      if (maxEcran >= minEcran) top = Math.max(minEcran, Math.min(top, maxEcran));
      pop.style.top = top + 'px';
      requestAnimationFrame(() => pop.classList.add('show'));
      openDot = dot;
    }));
    document.addEventListener('click', e => { if (openDot && !e.target.closest('[data-look-pop]') && !e.target.closest('.look__dot')) closePop(); });
  });

  // ---------- TILT 3D BENTO (curseur) ----------
  if (!touch && !reduce) {
    $$('.bento__tile').forEach(tile => {
      tile.addEventListener('pointermove', e => { const r = tile.getBoundingClientRect(); const px = (e.clientX - r.left) / r.width - .5, py = (e.clientY - r.top) / r.height - .5; tile.style.transform = `perspective(900px) rotateX(${(-py * 5).toFixed(2)}deg) rotateY(${(px * 6).toFixed(2)}deg)`; });
      tile.addEventListener('pointerleave', () => { tile.style.transform = 'perspective(900px) rotateX(0) rotateY(0)'; });
    });
  }

  // ---------- BANDE CINÉTIQUE (drift + vitesse de scroll + skew) ----------
  const kt = $('[data-kinetic-track]');
  if (kt && !reduce) {
    let offset = 0, half = 0, vel = 0, lastY = scrollY;
    const measure = () => { half = kt.scrollWidth / 2; };
    measure(); addEventListener('resize', measure, { passive: true });
    addEventListener('scroll', () => { const y = scrollY; vel += (y - lastY); lastY = y; }, { passive: true });
    const loop = () => {
      offset -= 0.6 + vel * 0.25;
      vel *= 0.9;
      if (half) { if (offset <= -half) offset += half; if (offset > 0) offset -= half; }
      const skew = Math.max(-9, Math.min(9, vel * 0.16));
      kt.style.transform = `translate3d(${offset}px,0,0) skewX(${skew}deg)`;
      requestAnimationFrame(loop);
    };
    requestAnimationFrame(loop);
  }

  // ---------- API partagée (boutique + fiche produit) ----------
  window.FN = { PRODUCTS, eur, card, matchCat, addToCart, addCustom, openCart, find, media, newsletterList: newsRead, newsletterExport: newsExport };
  // Lecture seule du panier — consommée par js/tracking.js (view_cart, begin_checkout)
  /* Lecture seule du panier — consommee par tracking.js (view_cart,
     begin_checkout). Source : le panier Shopify, plus le tableau local. */
  Object.defineProperty(window.FN, 'cart', { get: () => lignesPanier(), enumerable: true });
  Object.defineProperty(window.FN, 'subtotal', {
    get: () => (((window.FN_CART && FN_CART.get()) || {}).total_price || 0) / 100, enumerable: true });
})();
